import "./calendarSettings.scss";

import { isEqual } from "lodash";
import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import ErrorBoundary from "../../../components/errorBoundary";
import FormButton from "../../../components/form/FormButton";
import ModalFooter from "../../../components/modal/ModalFooter";
import ModalFooterRightGroup from "../../../components/modal/ModalFooterRightGroup";
import ModalHeading from "../../../components/modal/ModalHeading";
import ModalTabView from "../../../components/modal/ModalTabView";
import ModalView from "../../../components/modal/ModalView";
import PubSubTopics from "../../../constants/pubSubTopics";
import Dimensions from "../../../constants/styles/dimensions";
import dialogs from "../../../dialogs";
import { calendarMarkerSelectors } from "../../../modules/calendarMarkers";
import definitionReducer from "../../../modules/definition";
import { itemSelectors } from "../../../modules/items";
import CalendarSettingsEraTab from "./CalendarSettingsEraTab";
import CalendarSettingsMonthTab from "./CalendarSettingsMonthTab";
import CalendarSettingsWeekdayTab from "./CalendarSettingsWeekdayTab";

class CalendarSettingsModal extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      //#!if iOS !== true
      localStore: null,
      //#!endif
      activeTab: 0
    };

    this.dispatchLocal = this.dispatchLocal.bind(this);
    this.onDoneClick = this.onDoneClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.listItems = this.listItems.bind(this);
    this.onTabClick = this.onTabClick.bind(this);
  }

  componentWillMount() {
    this.copyLocalStore(this.props);
  }

  componentDidMount() {
    this._pubSubEscapeKeyDownToken = PubSub.subscribe(PubSubTopics.escapeKeyDown, this.onCloseClick);
  }

  componentWillReceiveProps(nextProps) {
    this.copyLocalStore(nextProps);
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this._pubSubEscapeKeyDownToken);
  }

  copyLocalStore(props) {
    //#!if iOS !== true
    this.setState({
      localStore: props.localStore
    });
    //#!endif
  }

  dispatchLocal(a) {
    //#!if iOS === true
// this.props.dispatchLocal(a);
    //#!else
    const newStore = this.state.localStore.set(
      "definitions",
      definitionReducer(this.state.localStore.definitions, a, this.state.localStore)
    );
    this.setState({ localStore: newStore });
    //#!endif
  }

  onDoneClick() {
    //#!if iOS === true
// this.props.onDoneClick();
    //#!else
    this.props.onDoneClick(this.state.localStore);
    //#!endif
  }

  onCloseClick() {
    //#!if iOS === true
// this.props.onCloseClick();
    //#!else
    this.props.onCloseClick();
    if (
      this.state.localStore !== this.props.localStore &&
      !isEqual(this.state.localStore.toJS(), this.props.localStore.toJS())
    ) {
      const msg = "Are you sure you want to close without applying your Calendar Settings changes?";
      dialogs.okCancelPrompt(msg, result => {
        if (result) {
          this.props.onCloseClick();
        }
      });
    } else {
      this.props.onCloseClick();
    }
    //#!endif
  }

  listItems = propItems => {
    return propItems
      .map((item, index) => {
        return {
          label: item.name,
          value: index,
          color: null,
          icon: null,
          canDelete: true
        };
      })
      .toArray();
  };

  onTabClick(index) {
    this.setState({
      activeTab: index
    });
  }

  tabViews() {
    let calendar = null;
    //#!if iOS === true
// calendar = this.props.localStore.definitions.calendar;
    //#!else
    calendar = this.state.localStore.definitions.calendar;
    //#!endif
    return [
      {
        icon: "settingsWeek",
        label: "Weekdays",
        view: (
          <CalendarSettingsWeekdayTab
            dispatchLocal={this.dispatchLocal}
            weekdays={calendar.weekdays}
            hoursInDay={calendar.hoursInDay}
            weekdayIndexAtZero={calendar.weekdayIndexAtZero}
            listItems={this.listItems}
            canEditDateData={this.props.canEditDateData}
            //#!if iOS === true
// onDoneClick={this.onDoneClick}
            //#!endif
          />
        )
      },
      {
        icon: "settingsMonth",
        label: "Months",
        view: (
          <CalendarSettingsMonthTab
            dispatchLocal={this.dispatchLocal}
            months={calendar.months}
            listItems={this.listItems}
            canEditDateData={this.props.canEditDateData}
            //#!if iOS === true
// onDoneClick={this.onDoneClick}
            //#!endif
          />
        )
      },
      {
        icon: "settingsEra",
        label: "Eras",
        view: (
          <CalendarSettingsEraTab
            dispatchLocal={this.dispatchLocal}
            eras={calendar.eras}
            ignoreEras={calendar.ignoreEras}
            leapCycles={calendar.leapCycles}
            listItems={this.listItems}
            canEditDateData={this.props.canEditDateData}
            //#!if iOS === true
// onDoneClick={this.onDoneClick}
            //#!endif
          />
        )
      }
    ];
  }

  renderModalFooter() {
    return (
      <ModalFooter>
        <ModalFooterRightGroup>
          <FormButton primary={true} label="OK" onClick={this.onDoneClick} />
        </ModalFooterRightGroup>
      </ModalFooter>
    );
  }

  render() {
    let localStore = null;
    //#!if iOS === true
// localStore = this.props.localStore;
    //#!else
    localStore = this.state.localStore;
    //#!endif

    let modalHeading = null;
    let modalFooter = null;
    let fixedHeight = null;

    // #!if iOS === true
// modalHeading = (
// <ModalHeading
// title="Edit Calendar"
// showBack={true}
// onBackClick={this.onCloseClick}
// showDone={true}
// onDoneClick={this.onDoneClick}
// />
// );
// fixedHeight = Dimensions.MODAL_MAX_HEIGHT;
    // #!else
    modalHeading = <ModalHeading title="Edit Calendar" showCancel={true} onCancelClick={this.onCloseClick} />;
    modalFooter = this.renderModalFooter();
    // #!endif

    return (
      <ModalView header={modalHeading} footer={modalFooter} fixedHeight={fixedHeight}>
        <ErrorBoundary store={localStore}>
          <ModalTabView
            tabs={this.tabViews()}
            onTabClick={this.onTabClick}
            //#!if iOS === true
// onDoneClick={this.onDoneClick}
            //#!endif
          />
        </ErrorBoundary>
      </ModalView>
    );
  }
}

CalendarSettingsModal.propTypes = {
  localStore: PropTypes.object.isRequired,
  //#!if iOS === true
// dispatchLocal: PropTypes.func.isRequired,
  //#!endif
  onDoneClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  canEditDateData: PropTypes.bool.isRequired,
  fontSize: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  canEditDateData:
    itemSelectors.getItemsWithSetDates(state.present).count() === 0 &&
    calendarMarkerSelectors.getCalendarMarkersList(state.present).count() === 0
});

export default connect(mapStateToProps)(CalendarSettingsModal);
